// import BaseModelInvestmentValuation from "@/models/BaseModelInvestmentValuation.js";
import BaseModelInvestment from "@/models/BaseModelInvestment.js";

export const GridConfig = {
	list: BaseModelInvestment.list,
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		InvestmentID: {
			class: 'value',
			dataName: 'InvestmentID',
			type: 'number',
			title: 'Investment ID',
			width: 120,
			hidden: false,
			readOnly: false
		},
		Title: {
			class: 'value',
			dataName: 'Title',
			type: 'string',
			title: 'Investment Name',
			width: 150,
			hidden: false,
			readOnly: false,
		},
		InvestmentGroup: {
			class: 'choice',
			dataName: 'InvestmentGroup',
			type: 'string',
			title: 'Investment Group',
			width: 220,
			hidden: false,
			readOnly: false
		},
		StatementOrder: {
			class: 'value',
			dataName: 'StatementOrder',
			type: 'number',
			title: 'Statement Order',
			width: 140,
			hidden: false,
			readOnly: false
		},
		Note: {
			class: 'value',
			dataName: 'Note',
			type: 'string',
			title: 'Note',
			width: 200,
			hidden: false,
			readOnly: false
		},
		ShowOnFMVS: {
			class: 'choice',
			dataName: 'ShowOnFMVS',
			type: 'string',
			title: 'Show on FMVS',
			width: 150,
			hidden: false,
			readOnly: false
		},
		HideNumberOnFMVS: {
			class: 'choice',
			dataName: 'HideNumberOnFMVS',
			type: 'string',
			title: 'Hide Number on FMVS',
			width: 150,
			hidden: false,
			readOnly: false
		},
	},
	grid: {
		gridId: 'InvestmentGrid',
		height: 500,
		actionsColumnWidth:110,
		checkbox: true,
		edit: true,
		delete: true,
		document: true,
		groupable: true,
	}
}

export const ToolbarConfig = {
	list: 'ToolBarItems',
	items: [

		{
			id: "btnAddInvestment",
			type: "button",
			text: "Add Investment",
			showIcon: "toolbar",
			icon: "plus-circle",
			attributes: { "class": "float-right-btn btn btn-primary" },

		},
		{
			id: "backTo",
			type: "button",
			text: "Back to Initial Issuance",
			showIcon: "toolbar",
			icon: "undo",
			attributes: { "class": "float-right-btn btn btn-secondary d-none" },
		},
		{
			id: "btnBulkImportUnitInvestmentValuation",
			type: "button",
			text: "Bulk Import",
			showIcon: "toolbar",
			icon: "upload",
			attributes: { "class": "float-right-btn btn btn-secondary" },

		}

	]
}